module.exports = __webpack_public_path__ + "static/img/sxcq.a053b68.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/jx/sxcq.png
// module id = T6a0
// module chunks = 0